module.exports = __webpack_public_path__ + "static/img/bg.29e0386b.jpg";